import {
  newAxios
} from '.'
const userId = true
import axios from 'axios'


export const Req_GetMyLessonList = data => {
  return newAxios({
    url: `/stu/subject/web/my/get`,
    data:{pageNum:1, pageSize: 100},
    userId
  })()
}

export const Req_GetLessonDetail = data => {
  return newAxios({
    url: `/stu/subject/detail/get`,
    userId,
    data
  })()
}

export const Req_GetVideoUrl = data => {
  return newAxios({
    url: `/stu/oss/get/play/url`,
    data
  })()
}

export const Req_SaveCollect = data => {
  return newAxios({
    url: `/stu/user/question/collect/save`,
    data,
    userId
  },'json')()
}

export const Req_UpdateClazzRecord = data => {
  return newAxios({
    url: `/stu/watch/record/save`,
    data,
    userId
  },'json')()
}

export const Req_CreateRandomTimes = data => {
  return newAxios({
    url: `/stu/user/question/collect/add/random`,
    data,
    userId
  },'json')()
}

export const Req_SaveViewTime = data => {
  return newAxios({
    url: `/stu/view/time/save/batch`,
    data,
    userId
  },'json')()
}

export const Req_CheckShowAnswer = data => {
  return newAxios({
    url: `/stu/subject/show/answer/get`,
    data,
    userId
  })()
}

export const Req_GetCertList = data => {
  return newAxios({
    url: `/stu/user/certificate/list`,
    userId
  })()
}

export const Req_CheckTimeValidity = data => {
  return newAxios({
    url: `/stu/subject/check/validity`,
    data
  })()
}


// WEBPACK FOOTER //
// ./src/ajax/lesson.js